import * as THREE from 'three';
import { CSS2DObject } from "three/addons/renderers/CSS2DRenderer.js";
import { Object3D } from "./Viewer.Object3D.js";

class LinearDimension extends Object3D {

    constructor(p0, p1, extrude, rebarLabel, materials) {
        super();

        this.type = 'LinearDimension';

        this.cb = {
            onChange: []
        };
        this.config = {
            headLength: 0.15,
            headWidth: 0.04,
            units: "m",
            precision: 2,
            unitsConverter: function(v) {
                return v.toFixed(this.precision);
            }
        };

        const direction = new THREE.Vector3().subVectors(p1, p0);
        this.length = direction.length();

        const lineGeometry = new THREE.BufferGeometry();
        lineGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, this.length, 0, 0], 3));

        const coneGeometry1 = new THREE.CylinderGeometry(
            this.config.headWidth,
            0,
            this.config.headLength,
            7,
            1
        );
        const coneGeometry2 = new THREE.CylinderGeometry(
            0,
            this.config.headWidth,
            this.config.headLength,
            7,
            1
        );

        if (this.config.headLength < 0.3 * this.length) {
            coneGeometry1.translate( 0, this.config.headLength/2, 0 );
            coneGeometry1.rotateZ( -Math.PI / 2 );
            coneGeometry2.translate( 0, - this.config.headLength/2, 0 );
            coneGeometry2.rotateZ( -Math.PI / 2 );
        } else {
            coneGeometry1.translate( 0, this.config.headLength/2, 0 );
            coneGeometry1.rotateZ( Math.PI / 2 );
            coneGeometry2.translate( 0, - this.config.headLength/2, 0 );
            coneGeometry2.rotateZ( Math.PI / 2 );
        }

        const coneMesh1 = new THREE.Mesh( coneGeometry1, materials.mesh );
        const coneMesh2 = new THREE.Mesh( coneGeometry2, materials.mesh );

        this.add( new THREE.Line( lineGeometry, materials.line ) );
        this.add( coneMesh1 );
        coneMesh2.position.x = this.length;
        this.add( coneMesh2 );

        const lineGeometry1 = new THREE.BufferGeometry();
        lineGeometry1.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, Math.sign(extrude) * 0.2 - extrude, 0, 0, Math.sign(extrude) * 0.1], 3));
        this.add( new THREE.Line( lineGeometry1, materials.line ) );
        const lineGeometry2 = new THREE.BufferGeometry();
        lineGeometry2.setAttribute('position', new THREE.Float32BufferAttribute([this.length, 0, Math.sign(extrude) * 0.2 - extrude, this.length, 0, Math.sign(extrude) * 0.1], 3));
        this.add( new THREE.Line( lineGeometry2, materials.line ) );

        this.position.copy( p0 );
        this.setDirection(direction);

        this.div = this.createLabelElement(`${this.config.unitsConverter(this.length)} ${this.config.units}`, rebarLabel);
        this.label = new CSS2DObject( this.div );
        this.label.position.set( this.length / 2, 0, 0 );
        this.add( this.label );

        this.translateZ(extrude);
    }

    createLabelElement( text, rebarInfo = '' ) {
        const div = document.createElement('div');

        div.className = 'dim-label';
        div.textContent = `${text}\n${rebarInfo}`;
        div.style.padding = '2px 4px';
        div.style.borderRadius = '4px';
        div.style.fontSize = '12px';
        div.style.background = 'rgb(255, 255, 255)';
        div.style.whiteSpace = 'pre';
        div.style.display = 'flex';
        div.style.justifyContent = 'center';
        div.style.alignItems = 'center';
        div.style.textAlign = 'center';

        return div;
    }

    setDirection( direction ) {
        // Create a quaternion that represents the rotation
        const quaternion = new THREE.Quaternion().setFromUnitVectors(
            new THREE.Vector3(1, 0, 0), // The Member's initial local x-axis
            direction.normalize() // The target direction vector
        );

        // Apply the quaternion to the Member to align it
        this.quaternion.copy(quaternion);

        // Since the local y-axis should remain parallel to the global y-axis,
        // additional adjustments should not be necessary unless the initial
        // orientation of the Member is not as assumed here.
    }
}

export { LinearDimension };